module.exports = __webpack_public_path__ + "static/img_9379-96d240c9003bbc86643c8e0bc280ab8b.webp";